import { useRouter } from 'next/router'
import NProgress from 'nprogress'
import { useEffect } from 'react'

/**
 * Integrates NProgress with Next.js router events to show a loading bar
 * during route transitions.
 */
export const useRouterProgress = () => {
    const router = useRouter()

    useEffect(() => {
        router.events.on('routeChangeStart', () => NProgress.start())
        router.events.on('routeChangeComplete', () => NProgress.done())
        router.events.on('routeChangeError', () => NProgress.done())

        return () => {
            router.events.off('routeChangeStart', () => NProgress.start())
            router.events.off('routeChangeComplete', () => NProgress.done())
            router.events.off('routeChangeError', () => NProgress.done())
        }
    }, [router])
}
